import React from "react";
import InertiaLink from "../buttons/InertiaLink";

export type PagyMetadata = {
  page: number;
  next: number | null;
  prev: number | null;
  pages: number;
  next_url: string;
  prev_url: string;
};

const PaginationControls: React.FC<PagyMetadata> = ({
  page,
  next,
  prev,
  pages,
  next_url,
  prev_url,
}) => {
  return (
    <div className="mt-auto mb-5 flex w-full items-center justify-center">
      <div className="flex items-center justify-around gap-10 rounded-lg bg-white px-2 py-2 shadow dark:bg-black">
        <InertiaLink
          text="<"
          type="primary"
          href={prev_url}
          disabled={!prev}
        />
        <span className="text-cream-700 dark:text-cream-300 font-bold">
          {page}
          <span className="text-cream-500 font-medium"> of {pages}</span>
        </span>

        <InertiaLink
          text=">"
          type="primary"
          href={next_url}
          disabled={!next}
        />
      </div>
    </div>
  );
};

export default PaginationControls;
